{
  "app": {
    "name": "UAchieve",
    "tagline": "Booking system",
    "taglineLong": "Booking management system",
    "title": "UAchieve · Booking system"
  },
  "actions": {
    "retry": "Try again",
    "back": "Go back",
    "working": "Working…",
    "download": "Download",
    "change": "Change",
    "home": "Back to home"
  },
  "loading": "Loading",
  "pagination": {
    "label": "Pages",
    "showing": "Showing {{from}}–{{to}} of {{total}}",
    "previous": "Previous",
    "next": "Next"
  },
  "file": {
    "onlyTypes": "Only PDF, JPG or PNG files are allowed",
    "tooLarge": "The file is larger than 10 MB",
    "dropHere": "Drop the file here or choose from your device",
    "typesHint": "PDF, JPG or PNG · up to 10 MB",
    "previewFailed": "Preview unavailable — download the file to view it."
  },
  "search": {
    "global": "Search by booking reference, customer name or phone",
    "globalLabel": "Search by booking reference, customer name or phone"
  },
  "theme": {
    "toDark": "Dark mode",
    "toLight": "Light mode"
  },
  "language": {
    "switch": "العربية",
    "switchLabel": "Switch to Arabic"
  },
  "topbar": {
    "menu": "Menu",
    "breadcrumb": "Breadcrumb"
  },
  "agreementChip": {
    "percentage": "{{label}} of fee",
    "fixed": "Fixed {{label}}"
  },
  "status": {
    "booking": {
      "draft": "Draft",
      "confirmed": "Confirmed",
      "invoiced": "Invoiced",
      "paid": "Paid",
      "cancelled": "Cancelled",
      "refunded": "Refunded"
    },
    "invoice": {
      "pending_send": "Sending",
      "sent": "Sent",
      "paid": "Paid",
      "payment_failed": "Payment failed",
      "send_failed": "Send failed",
      "cancelled": "Cancelled",
      "expired": "Expired",
      "rejected": "Rejected"
    },
    "commission": {
      "pending": "Pending",
      "earned": "Earned",
      "paid": "Transferred",
      "void": "Void",
      "reversed": "Reversed"
    },
    "portal": {
      "active": "Active",
      "invited": "Invite sent",
      "none": "No account",
      "disabled": "Disabled"
    },
    "contract": {
      "active": "Active",
      "expiring": "Expiring soon",
      "expired": "Expired",
      "no_dates": "No dates"
    },
    "partner": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "agreement": {
      "current": "Current",
      "scheduled": "Scheduled",
      "past": "Ended",
      "cancelled": "Cancelled"
    },
    "signing": {
      "sent": "Sent",
      "viewed": "Viewed",
      "signed": "Signed",
      "expired": "Link expired",
      "cancelled": "Cancelled"
    }
  },
  "errors": {
    "networkTitle": "Can't reach the server",
    "networkDetail": "Check your internet connection and try again.",
    "server": "Something went wrong on the server. Please try again.",
    "generic": "Something went wrong",
    "fallbackTitle": "Error",
    "forbidden": "You don't have permission to view this page",
    "notFound": "Page not found",
    "crashed": "Something went wrong"
  },
  "auth": {
    "agency": "UAchieve agency",
    "headline": "Your gateway to the world, all your bookings in one place",
    "body": "Bookings through our partners, invoices delivered to the customer's phone, and coordinator commissions calculated automatically.",
    "pills": {
      "bookings": "Partner bookings",
      "invoices": "Invoices by SMS",
      "billing": "StreamPay billing"
    }
  },
  "statusSource": {
    "app": "the app",
    "webhook": "webhook",
    "status_api": "status check",
    "reconcile": "nightly reconcile"
  },
  "statusChanged": "Status last updated via {{source}} · {{at}}",
  "signature": {
    "placeholder": "Draw your signature here",
    "hint": "Use your finger, mouse or pen",
    "clear": "Clear",
    "how": "Signature method",
    "draw": "Draw",
    "upload": "Upload image",
    "uploadPrompt": "Choose your signature image or drop it here",
    "uploadHint": "PNG, JPG or WebP up to 5 MB",
    "uploadType": "Allowed: PNG, JPG or WebP",
    "uploadSize": "The image is larger than 5 MB",
    "whiteRemoved": "A white background is removed automatically",
    "remove": "Remove"
  }
}
